import { FormattedMessage } from "react-intl";

export const checkNameLengthAndCharacters = (nameToCheck) => {
  // do the test strings contain these terms?
  const conditions = ["<", ">", "\\", "/"];

  if (conditions.some((el) => nameToCheck.includes(el))) {
    return <FormattedMessage id="InvalidCharactersInName" />;
  } else if (nameToCheck.trim().length > 50) {
    return <FormattedMessage id="NameTooLongMaxIs50" />;
  } else {
    return true;
  }
};
